import React, { useEffect, useState } from "react";
import {
  isNavigationBusy,
  pendingNotice,
  runPendingNavigation,
  subscribePendingNavigation,
} from "../utils/deferredNavigation";

// Persistent notice for a queued reload / sign-in redirect (see
// utils/deferredNavigation): why it is waiting, and once nothing is busy a
// button to run it now ("Refresh" / "Sign in now"). It never runs by itself
// from here; the queue runs it only on that click or at a natural boundary.
const sameView = (a, b) =>
  a === b || (!!a && !!b && a.text === b.text && a.action === b.action);

export default function DeferredNavigationNotice() {
  const [view, setView] = useState(() => pendingNotice());

  useEffect(() => {
    const update = () => {
      const next = pendingNotice();
      setView((prev) => (sameView(prev, next) ? prev : next));
    };
    update();
    return subscribePendingNavigation(update);
  }, []);

  if (!view) return null;

  return (
    <div
      role="status"
      style={{
        position: "fixed",
        bottom: 72,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        maxWidth: "92vw",
        background: "#16294F",
        color: "#fff",
        padding: "10px 16px",
        borderRadius: 12,
        boxShadow: "0 6px 20px rgba(0,0,0,.25)",
        display: "flex",
        alignItems: "center",
        gap: 12,
        fontSize: 14,
      }}
    >
      <span>{view.text}</span>
      {view.action && (
        <button
          type="button"
          onClick={() => {
            // The button is offered only once nothing is busy; re-check at
            // the click in case a recording has started since.
            if (!isNavigationBusy()) runPendingNavigation();
          }}
          style={{
            background: "#2E6EE2",
            color: "#fff",
            border: "none",
            padding: "6px 14px",
            borderRadius: 999,
            cursor: "pointer",
            fontWeight: 600,
            whiteSpace: "nowrap",
          }}
        >
          {view.action}
        </button>
      )}
    </div>
  );
}
